import { render, staticRenderFns } from "./ManageCategories.vue?vue&type=template&id=6e5fbf2e&scoped=true&"
import script from "./ManageCategories.vue?vue&type=script&lang=js&"
export * from "./ManageCategories.vue?vue&type=script&lang=js&"
import style0 from "./ManageCategories.vue?vue&type=style&index=0&id=6e5fbf2e&prod&lang=css&"
import style1 from "./ManageCategories.vue?vue&type=style&index=1&id=6e5fbf2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5fbf2e",
  null
  
)

export default component.exports